"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var folders;
        (function (folders) {
            var edit;
            (function (edit) {
                function init() {
                    addEvents();
                }
                edit.init = init;
                function addEvents() {
                    $('button').click(function () {
                        window.parent.folderSave = true;
                    });
                }
            })(edit = folders.edit || (folders.edit = {}));
        })(folders = views.folders || (views.folders = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
